import "./SectionFour.css";

import React, { useRef } from "react";

import { Link } from "react-router-dom";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import sectionFourMap from "../../../../shared/imageAssets/sectionFourMap.jpg";

export const SectionFour = () => {
  const sectionFourMapContainer = useRef(null);
  const sectonFourCountriesListContainer = useRef(null);
  const sectionFourCofeecupSubsection1 = useRef(null);
  const sectionFourMapOnload = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("section-four-map-animation");
        }
      });
    });
    observer.observe(sectionFourMapContainer.current);
  };
  const sectonFourCountriesListOnLoad = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("asd");
          // entry.target.classList.add("section-four-map-animation");
        }
      });
    });
    observer.observe(sectonFourCountriesListContainer.current);
  };
  const sectionFourCofeecupSubsection1OnLoad = () => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log("asdasd");
          entry.target.classList.add(
            "section-four-cofeecup-subsection-1-animation"
          );
        }
      });
    });
    observer.observe(sectionFourCofeecupSubsection1.current);
  };
  const handleMoveToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="section-four-container">
      <div className="section-four-map-subsection">
        <div className="section-four-text-container">
          <h1 className="section-four-h1-1">Методи за доставка</h1>
          <p className="section-four-p">
            Доставки се извършват чрез ЕКОНТ, до офис на ЕКОНТ или до посочен
            адрес
          </p>
          <Link
            to={"/shop"}
            onClick={handleMoveToTop}
            className="section-four-all-products-button"
            href="#"
          >
            към каталог
          </Link>
        </div>
        <div
          ref={sectionFourMapContainer}
          onLoad={sectionFourMapOnload}
          className="section-four-map-container"
        >
          <img className="section-four-map" src={sectionFourMap}></img>
        </div>
      </div>
      <div className="section-four-cofeecup-subsection">
        <div
          ref={sectionFourCofeecupSubsection1}
          onLoad={sectionFourCofeecupSubsection1OnLoad}
          className="section-four-cofeecup-subsection-1"
        >
          <p className="section-four-cofeecup-subsection-1-title">Над</p>
          <div
            style={{ display: "flex" }}
            className="section-four-cofeecup-subsection-1-numbers"
          >
            <h1 className="section-four-cofeecup-subsection-1-numbers-3">3</h1>
            <h1 className="section-four-cofeecup-subsection-1-numbers-0">0</h1>
            <h1 className="section-four-cofeecup-subsection-1-numbers-0">0</h1>
          </div>

          <p className="section-four-cofeecup-subsection-1-text">
            футболиста, професионални и любители, са се доверили на нас.
          </p>
        </div>
      </div>
    </div>
  );
};
